import moment from 'moment';

moment.updateLocale('en', {
    relativeTime: {
        ss: "%d seconds"
    }
});
